/* B360 landing pages: language switch (English / Arabic).
   English is the page exactly as built; nothing here changes it. Choosing Arabic swaps each English string for its Arabic translation
   (dictionary: assets/b360-lang-ar.js, loaded only then) and switches the fonts; choosing English swaps everything back.
   The choice is remembered in this browser (localStorage) so the hub, the landing pages and the next visit agree. No data leaves the browser. */
(function () {
  'use strict';
  var html = document.documentElement;
  var btn = document.querySelector('[data-b360-lang-toggle]');
  var cfgEl = document.getElementById('b360-lang-config');
  if (!btn || !cfgEl) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var KEY = 'b360_lang';
  function stored() { try { return window.localStorage.getItem(KEY); } catch (e) { return null; } }
  function store(v) { try { window.localStorage.setItem(KEY, v); } catch (e) {} }

  var lang = 'en', dict = null, loading = null, observer = null, busy = false;
  var saved = { text: new Map(), attr: new Map(), align: new Map(), own: new Map(), story: null };
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|CODE)$/;
  var ATTRS = ['aria-label', 'alt', 'title'];
  var norm = function (s) { return String(s).replace(/\s+/g, ' ').trim(); };
  var root = function () { return document.getElementById('MainContent') || document.body; };
  var extraRoots = function () { return [].slice.call(document.querySelectorAll('[data-bs-drawer], [data-b360-pv], [data-b360-acct]')); };

  /* ---------- the button: top right, slides up when scrolling down, returns when scrolling up ---------- */
  var lastY = Math.max(0, window.scrollY), ticking = false;
  function headerBottom() {
    var hs = document.querySelectorAll('[id$="__header"], header'), r = null, i;
    for (i = 0; i < hs.length; i++) { var q = hs[i].getBoundingClientRect(); if (q.height > 0) { r = q; break; } }
    if (!r) return 0;
    return r.bottom > 0 ? Math.round(r.bottom) : 0;
  }
  function place() { btn.style.setProperty('--b360-lang-top', (headerBottom() + 12) + 'px'); }
  function show() { btn.classList.remove('is-away'); }
  function hide() { btn.classList.add('is-away'); }
  function onScroll() {
    if (ticking) return; ticking = true;
    window.requestAnimationFrame(function () {
      var y = Math.max(0, window.scrollY), d = y - lastY;
      if (y <= 120) show(); else if (d > 6) hide(); else if (d < -6) show();
      if (Math.abs(d) > 6 || y <= 120) lastY = y;
      place(); ticking = false;
    });
  }
  place();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', place, { passive: true });
  btn.addEventListener('focus', show);

  /* ---------- translation ---------- */
  function lookup(key, el) {
    var i, r;
    if (dict.scoped) for (i = 0; i < dict.scoped.length; i++) { r = dict.scoped[i]; if (r.en === key && el.closest && el.closest(r.sel)) return r.ar; }
    if (Object.prototype.hasOwnProperty.call(dict.exact, key)) return dict.exact[key];
    if (dict.starts) { var kk = key.replace(/[\u2018\u2019]/g, "'"); for (i = 0; i < dict.starts.length; i++) { if (kk.indexOf(dict.starts[i][0].replace(/[\u2018\u2019]/g, "'")) === 0) return dict.starts[i][1]; } }
    if (dict.patterns) for (i = 0; i < dict.patterns.length; i++) { if (dict.patterns[i][0].test(key)) return key.replace(dict.patterns[i][0], dict.patterns[i][1]); }
    return null;
  }
  /* Proper right-to-left. Inside the campaign sections (.sp) the whole section is set to dir=rtl, so grids, rows and text-align:start mirror by themselves.
     Anywhere else (a product page) only the translated text block reads right-to-left and is aligned to the right, the page's own layout is left alone. */
  function keepAlign(el) {
    if (el.closest && el.closest('.sp')) return;
    var b = el, cs;
    while (b && b !== document.body) { cs = window.getComputedStyle(b); if (cs.display !== 'inline' && cs.display !== 'contents') break; b = b.parentElement; }
    if (!b || b === document.body || saved.align.has(b)) return;
    saved.align.set(b, b.getAttribute('dir') || ''); b.setAttribute('dir', 'rtl');
  }
  function textNode(n) {
    var p = n.parentElement;
    if (!p || SKIP.test(p.tagName) || (p.closest && p.closest('[data-b360-lang-toggle]'))) return;
    var raw = n.nodeValue, key = norm(raw);
    if (!key) return;
    var ar = lookup(key, p);
    if (ar === null) return;
    if (!saved.text.has(n)) saved.text.set(n, raw);
    n.nodeValue = raw.match(/^\s*/)[0] + ar + raw.match(/\s*$/)[0];
    keepAlign(p);
  }
  function attrs(el) {
    if (!el.getAttribute) return;
    ATTRS.forEach(function (a) {
      var v = el.getAttribute(a); if (!v) return;
      var ar = lookup(norm(v), el); if (ar === null) return;
      var m = saved.attr.get(el) || {}; if (!(a in m)) m[a] = v; saved.attr.set(el, m);
      el.setAttribute(a, ar);
    });
  }
  /* a text block that carries its own Arabic (data-b360-ar): written in Arabic on the page itself, not looked up in the dictionary */
  function own(el) {
    var ar = el.getAttribute && el.getAttribute('data-b360-ar');
    if (!ar || saved.own.has(el)) return false;
    saved.own.set(el, el.innerHTML); el.textContent = ar; keepAlign(el); return true;
  }
  function walk(node) {
    if (node.nodeType === 3) return textNode(node);
    if (node.nodeType !== 1 || SKIP.test(node.tagName)) return;
    if (own(node)) return;
    attrs(node);
    var tw = document.createTreeWalker(node, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, null), n;
    while ((n = tw.nextNode())) { if (n.nodeType === 3) textNode(n); else if (!SKIP.test(n.tagName)) { if (own(n)) { tw.currentNode = n.lastChild || n; continue; } attrs(n); } }
  }
  function story() {
    var el = document.querySelector('.sp-story__text');
    if (!el || saved.story || !dict.story) return;
    if (norm(el.textContent) !== norm(dict.story.en)) return;
    saved.story = { el: el, html: el.innerHTML, n: el.style.getPropertyValue('--n') };
    var words = norm(dict.story.ar).split(' ');
    el.innerHTML = words.map(function (w, i) { return '<span class="w" style="--i: ' + i + '">' + w + ' </span>'; }).join('');
    el.style.setProperty('--n', words.length);
    keepAlign(el);
  }
  function translateAll() {
    busy = true;
    var r = root();
    walk(r); story();
    [].forEach.call(document.querySelectorAll('.sp'), function (s) { s.setAttribute('lang', 'ar'); s.setAttribute('dir', 'rtl'); });
    extraRoots().forEach(walk);
    busy = false;
    if (observer) observer.takeRecords();
  }
  function restoreAll() {
    busy = true;
    saved.text.forEach(function (raw, n) { n.nodeValue = raw; }); saved.text.clear();
    saved.own.forEach(function (html, el) { el.innerHTML = html; }); saved.own.clear();
    saved.attr.forEach(function (m, el) { for (var a in m) el.setAttribute(a, m[a]); }); saved.attr.clear();
    saved.align.forEach(function (v, el) { if (v) el.setAttribute('dir', v); else el.removeAttribute('dir'); }); saved.align.clear();
    if (saved.story) { saved.story.el.innerHTML = saved.story.html; if (saved.story.n) saved.story.el.style.setProperty('--n', saved.story.n); saved.story = null; }
    [].forEach.call(document.querySelectorAll('.sp'), function (s) { s.removeAttribute('lang'); s.removeAttribute('dir'); });
    busy = false;
  }
  function observe() {
    if (observer || typeof MutationObserver !== 'function') return;
    observer = new MutationObserver(function (list) {
      if (busy) return;
      busy = true;
      list.forEach(function (m) {
        if (m.type === 'characterData') textNode(m.target);
        else if (m.type === 'attributes') attrs(m.target);
        else m.addedNodes.forEach(function (n) { walk(n); });
      });
      busy = false; observer.takeRecords();
    });
    var opts = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS };
    observer.observe(root(), opts); extraRoots().forEach(function (n) { observer.observe(n, opts); });
  }

  /* ---------- assets, only when Arabic is chosen ---------- */
  function load(src) { return new Promise(function (res, rej) { var s = document.createElement('script'); s.src = src; s.onload = res; s.onerror = rej; document.head.appendChild(s); }); }
  function fonts() {
    if (document.getElementById('b360-lang-fonts')) return Promise.resolve();
    var l = document.createElement('link'); l.id = 'b360-lang-fonts'; l.rel = 'stylesheet'; l.href = cfg.fonts; document.head.appendChild(l);
    var wait = (document.fonts && document.fonts.load) ? Promise.all([document.fonts.load('400 20px Amiri', 'ع'), document.fonts.load('400 16px "IBM Plex Sans Arabic"', 'ع')]).catch(function () {}) : Promise.resolve();
    return Promise.race([wait, new Promise(function (r) { setTimeout(r, 1800); })]);
  }
  function ready() {
    if (dict) return Promise.resolve();
    if (!loading) loading = load(cfg.dict).then(function () { dict = window.B360_AR; });
    return loading;
  }

  function label() {
    if (lang === 'ar') { btn.setAttribute('lang', 'en'); btn.setAttribute('aria-label', 'Switch to English'); btn.firstElementChild.textContent = 'English'; }
    else { btn.setAttribute('lang', 'ar'); btn.setAttribute('aria-label', 'التبديل إلى العربية'); btn.firstElementChild.textContent = 'العربية'; }
  }
  function done() { html.removeAttribute('data-b360-lang-pending'); }

  function set(next, persist) {
    if (next === lang) { done(); return Promise.resolve(); }
    if (next === 'ar') {
      lang = 'ar'; label(); if (persist) store('ar');
      return Promise.all([ready(), fonts()]).then(function () {
        if (lang !== 'ar') return;
        html.setAttribute('data-b360-lang', 'ar'); translateAll(); observe(); done();
      }, function () { lang = 'en'; label(); html.removeAttribute('data-b360-lang'); done(); });
    }
    lang = 'en'; label(); if (persist) store('en');
    if (observer) { observer.disconnect(); observer = null; }
    restoreAll(); html.removeAttribute('data-b360-lang'); done();
    return Promise.resolve();
  }

  btn.addEventListener('click', function () { set(lang === 'ar' ? 'en' : 'ar', true); });
  /* the store's own Arabic address (/ar/...) opens these pages in Arabic unless the visitor has chosen English here */
  var onAr = /^\/ar(\/|$)/.test(window.location.pathname), pref = stored();
  if (pref === 'ar' || (onAr && pref !== 'en')) set('ar', false); else done();
})();
